import styled from "styled-components/native";
import { pickStyle as _ } from "utils";

import { EmojiSize, EmojiTopOffset, EmojiLeftOffset } from "./variables";

export const LineStart = styled.View`
  position: absolute;
  height: 50%;
  width: 55%;
  top: -50%;
  left: 50%;
  border: solid 1px white;
  border-right-width: 0;
  border-bottom-width: 0;
  border-radius: 2px;
`;

export const LineRepeat = styled.View`
  position: absolute;
  height: 50%;
  width: 105%;
  top: -50%;
  border: solid 1px white;
  border-left-width: 0;
  border-right-width: 0;
  border-bottom-width: 0;
`;

export const LineEnd = styled.View`
  position: absolute;
  height: 50%;
  width: 55%;
  top: -50%;
  right: 50%;
  border: solid 1px white;
  border-left-width: 0;
  border-bottom-width: 0;
  border-radius: 2px;
`;

export const Emoji = styled.Image`
  position: absolute;
  top: ${_(EmojiTopOffset) || -150}%;
  width: ${_(EmojiSize) || 40}px;
  height: ${_(EmojiSize) || 40}px;
  z-index: 10;
`;

export const OffsetEmoji = styled(Emoji)`
  left: ${_(EmojiLeftOffset) || 75}%;
`;
